"use client";

import React from "react";
import Footer from "@/components/layout/Footer";
import { NewsCarousel } from "./components/NewsCarousel";
import { NewsList } from "./components/NewsList";
import { EmptyNewsState } from "./components/EmptyNewsState";
import { useNewsPageData } from "./hooks/useNewsPageData";

/**
 * NewsPage Component
 * Main component for the News page that composes all sections
 */
export default function NewsPage() {
  const { carouselNews, allNews, loading, error, refreshData } =
    useNewsPageData();

  if (loading) {
    return (
      <div className="">
        {/* Loading Content */}
        <div className="bg-gray-50 py-8">
          {/* Loading Carousel */}
          <div className="max-w-6xl mx-auto px-4 mb-8">
            <div className="w-full h-96 md:h-[500px] bg-gray-200 rounded-lg animate-pulse" />
          </div>

          {/* Loading News Grid */}
          <div className="max-w-6xl mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[...Array(6)].map((_, i) => (
                <div
                  key={i}
                  className="bg-white rounded-lg shadow-md overflow-hidden"
                >
                  <div className="h-48 bg-gray-200 animate-pulse" />
                  <div className="p-4">
                    <div className="h-4 bg-gray-200 rounded mb-2 animate-pulse" />
                    <div className="h-6 bg-gray-200 rounded mb-2 animate-pulse" />
                    <div className="h-4 bg-gray-200 rounded animate-pulse" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="">
        <div className="bg-gray-50 py-8">
          <div className="max-w-6xl mx-auto px-4">
            <EmptyNewsState title="Lỗi khi tải tin tức" description={error} />
            <div className="text-center mt-6">
              <button
                onClick={refreshData}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md font-medium transition-colors"
              >
                Thử lại
              </button>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }

  return (
    <div className="">
      {/* Main content area */}
      <div className="bg-gray-50 py-8">
        {/* Featured News Carousel */}
        {carouselNews.length > 0 && (
          <div className="max-w-6xl mx-auto px-4">
            <NewsCarousel news={carouselNews} />
          </div>
        )}

        {/* All News List */}
        <NewsList allNews={allNews} />
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}
